import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const Wrapper = styled.div`
  box-shadow: 0px 2px 21px 0px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 0px 2px 21px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 21px 0px rgba(0, 0, 0, 0.75);
  padding: 20px;
  border-radius: 5px;
  background-color: white;

  svg {
    color: #000;
  }
`;
